import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import api2 from "../../../utils/Url2";


type Props = {};

const mrnTypeOption = [
  { value: "IOT", label: "IOT" },
  { value: "GSM", label: "GSM" },
  { value: "LTE", label: "LTE" },
  { value: "CDMA", label: "CDMA" },
];


const VehicleDetailAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();
  const [toaster, setToaster] = useState(false);
  const [vendorData, setVendorData] = useState([]);
  const [vendorDetail, setVendorDetail] = useState<any>();
  const initialRowData = {
    // id: -1,
    // mrnId: 0,
    // mrnType: "",
    // orderId: -1,
    // orderNo: "",
    // batchNo: "",
    // serialNo: "",
    // qcStatus: "",
    // itemId: '',
    // balQuantity: '',
    // quantity: '',
    // rate: '',
    // amount: '',
    // gstId: 0,
    // gstRate: 0,
    // cgst: 0,
    // sgst: 0,
    // igst: 0,
    // cgstid:0,
    // sgstid: 0,
    // igstid: 0,
    // gst: 0,
    // netAmount: '',
    // item: {}
  };
  const [vehicleOption, setvehicleOption] = useState([
    { value: -1, label: t("text.vehicleTypeId") },
  ]);

  const [brandOption, setbrandOption] = useState([
    { value: -1, label: t("text.brandId") },
  ]);

  const [fuelTypeOption, setfuelTypeOption] = useState([
    { value: -1, label: t("text.fuelTypeId") },
  ]);

  const [taxOption, settaxOption] = useState([
    { value: -1, label: t("text.taxId") },
  ]);

  const [unitOption, setunitOption] = useState([
    { value: -1, label: t("text.unitId") },
  ]);

  const [zoneOption, setzoneOption] = useState([
    { value: -1, label: t("text.zoneID") },
  ]);

  const [categoryOption, setcategoryOption] = useState([
    { value: -1, label: t("text.itemCategoryId") },
  ]);

  const [empOption, setempOption] = useState([
    { value: -1, label: t("text.empid") },
  ]);

  const [deviceOption, setdeviceOption] = useState([
    { value: -1, label: t("text.id") },
  ]);

  const [v1Option, setv1Option] = useState([
    { value: -1, label: t("text.itemTypeMasterId") },
  ]);

  const [departmentOption, setdepartmentOption] = useState([
    { value: -1, label: t("text.departmentId") },
  ]);
  const [designationOption, setdesignationOption] = useState([
    { value: -1, label: t("text.designationId") },
  ]);

  useEffect(() => {
    getVehicleData();
    getbrandData();
    getfuelTypeData();
    gettaxData();
    getunitData();
    getzoneData();
    getcategoryData();
    getempData();
    getdeviceData();
    getdepartmentData();
    getdesignationData();
    getv1Data();
  }, []);

  const getVehicleData = async () => {
    const collectData = {
      "vehicleTypeId": -1,
      "vehicleTypename": ""
    };
    const response = await api.post(`VehicleType/GetVehicleType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["vehicleTypename"],
        value: data[index]["vehicleTypeId"],
      });
    }
    setvehicleOption(arr);
  };

  const getdepartmentData = async () => {
    const collectData = {
      "departmentId": -1,
      "departmentName": ""
    };
    const response = await api.post(`Department/GetDepartmentmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["departmentName"],
        value: data[index]["departmentId"],
      });
    }
    setdepartmentOption(arr);
  };

  const getdesignationData = async () => {
    const collectData = {
      "designationId": -1,

    };
    const response = await api.post(`Designation/GetDesignationmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["designationName"],
        value: data[index]["designationId"],
      });
    }
    setdesignationOption(arr);
  };

  const getbrandData = async () => {
    const collectData = {
      "brandId": -1,
      "brandname": "",
      "brandshortname": "",
      "brandCode": "",
      "createdBy": ""
    };
    const response = await api.post(`Brand/GetBrand`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["brandname"],
        value: data[index]["brandId"],
      });
    }
    setbrandOption(arr);
  };

  const getfuelTypeData = async () => {
    const collectData = {
      "fuelTypeId": -1,
      "fuelTypename": ""
    };
    const response = await api.post(`FuelType/GetFuelType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["fuelTypename"],
        value: data[index]["fuelTypeId"],
      });
    }
    setfuelTypeOption(arr);
  };

  const gettaxData = async () => {
    const collectData = {
      "taxId": -1,
    };
    const response = await api.post(`TaxMaster/GetTaxMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["taxName"],
        value: data[index]["taxId"],
      });
    }
    settaxOption(arr);
  };


  const getunitData = async () => {
    const collectData = {
      "unitId": -1,
    };
    const response = await api.post(`UnitMaster/GetUnitMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["unitName"],
        value: data[index]["unitId"],
      });
    }
    setunitOption(arr);
  };

  const getzoneData = async () => {
    const collectData = {
      "zoneID": -1,
      "user_ID": "",
      "isActive": true
    };
    const response = await api.post(`Zone/GetZonemaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["zoneName"],
        value: data[index]["zoneID"],
      });
    }
    setzoneOption(arr);
  };

  const getcategoryData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",
      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true
    };
    const response = await api.post(`ItemCategory/GetItemCategory`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemCategory"],
        value: data[index]["itemCategoryId"],
      });
    }
    setcategoryOption(arr);
  };

  const getempData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",

      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "intvalue1": 0,
      "intvalue2": 0,
      "intvalue3": 0,
      "intvalue4": 0,
      "intnotnullvalue2": 0,
      "intnotnullvalue3": 0,
      "dec1": 0,
      "dec2": 0,
      "dec3": 0,
      "dec4": 0,
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true
    };
    const response = await api.post(`Employee/GetEmployee`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["empName"],
        value: data[index]["empid"],
      });
    }
    setempOption(arr);
  };

  const getv1Data = async () => {
    const collectData = {
      "itemTypeMasterId": -1,
    };
    const response = await api.post(`ItemTypeMaster/GetItemTypeMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemType"],
        value: data[index]["itemTypeMasterId"],
      });
    }
    setv1Option(arr);
  };

  const getdeviceData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",

      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "intvalue1": 0,
      "intvalue2": 0,
      "intvalue3": 0,
      "intvalue4": 0,
      "intnotnullvalue2": 0,
      "intnotnullvalue3": 0,
      "date1": defaultValues,
      "date2": defaultValues,
      "date3": defaultValues,
      "date4": defaultValues,
      "dec1": 0,
      "dec2": 0,
      "dec3": 0,
      "dec4": 0,
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true

    };
    const response = await api.post(`DeviceType/GetDeviceType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["dtype"],
        value: data[index]["id"],
      });
    }
    setdeviceOption(arr);
  };


  const formik = useFormik({
    initialValues: {
      "activeClass": "",
      "all": true,
      "showExisting": true,
      "isSuccess": true,
      "message": "",
      "srno": 0,
      "eScarp": true,
      "eScarpPrevValue": "",
      "css": "",
      "itemMasterId": 0,
      "itemName": "",
      "itemCode": "",
      "itemTypeId": 0,
      "itemFlag": "",
      "itemCategoryId": 0,
      "unitId": 0,
      "empId": 0,
      "taxId": 0,
      "purchaseYear": 0,
      "modelNo": "",
      "serialNo": "",
      "vehicleNo": "",
      "vZoneID": 0,
      "hsnCode": "",
      "chesisNo": "",
      "qcApplicable": true,
      "depreciationRate": 0,
      "createdBy": "",
      "updatedBy": "",
      "devid": "",
      "existDevid": "",
      "simNo": "",
      "simCompany": "",
      "simType": "",
      "deviceTypeId": 0,
      "existSimNo": "",
      "devidRemark": "",
      "simNoRemark": "",
      "seviceEnggCode": "",
      "simContactNo": "",
      "gpsType": "",
      "gpsid": "",
      "workType": "",
      "replacement": "",
      "repair": true,
      "zoneName": "",
      "createdOn": defaultValues,
      "updatedOn": defaultValues,
      "mileage": 0,
      "litrePerHr": 0,
      "kmPerLitre": 0,
      "fuelAlloted": 0,
      "srn": 0,
      "vehicleTypeId": 0,
      "brandTypeId": 0,
      "fuelTypeId": 0,
      "ntRecord": "",
      "vehicleWeight": 0,
      "departmentName": "",
      "designationName": "",
      "rfid": "",
      "rfid2": "",
      "deptId": 0,
      "desigId": 0

    },

    validationSchema: Yup.object({
      hsnCode: Yup.string()
        .required(t("text.reqHSNCode")),
      vehicleNo: Yup.string()
        .required(t("text.reqVehicleNum")),
      simNo: Yup.string()
        .required(t("text.reqSimNum")),
        modelNo: Yup.string()
        .required(t("text.reqModelNo")),
    }),

    onSubmit: async (values) => {
      // values.vendor = vendorDetail;

      const response = await api.post(`ItemMaster/AddUpdateItemMaster`, values);
      if (response.data.status === 1) {
        setToaster(false);
        toast.success(response.data.message);
        navigate("/vehiclemanagement/vehicledetail");
      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.VehicleDetailAdd")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster == false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={zoneOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("vZoneID", newValue?.value.toString());
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectZone")}
                          required={false}
                        />
                      }
                    />
                  )}
                />
              </Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.VehicleName")}
                  value={formik.values.itemName}
                  onChangeText={(text: string) => formik.setFieldValue("itemName", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.VehicleName")}
                />
                {formik.touched.itemName && formik.errors.itemName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.itemName}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.EnterCode")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="itemCode"
                  id="itemCode"
                  placeholder={t("text.EnterCode")}
                  value={formik.values.itemCode}
                  onChange={formik.handleChange}
                />
                {formik.touched.itemCode && formik.errors.itemCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.itemCode}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="hsnCode"
                  name="hsnCode"
                  label={<CustomLabel text={t("text.HsnCode")} required={true} />}
                  placeholder={t("text.HsnCode")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.hsnCode && formik.errors.hsnCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.hsnCode}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={categoryOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("itemCategoryId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={<CustomLabel text={t("text.Category")} required={false} />} />
                  )}
                />
              </Grid>




              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={v1Option}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("itemTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleTypeName")} required={false} />}
                    />
                  )}
                />
              </Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={unitOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("unitName", newValue?.label);
                    formik.setFieldValue("unitId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.EnterUnit")} />}
                    />
                  )}
                />
              </Grid>




              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={taxOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("taxName", newValue?.label);
                    formik.setFieldValue("taxId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.Tax")} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.entermodelNo")}
                  value={formik.values.modelNo}
                  onChangeText={(text: string) => formik.setFieldValue("modelNo", text)}
                  required={true}
                  lang={lang}
                />

                {formik.touched.modelNo && formik.errors.modelNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.modelNo}
                  </div>
                ) : null}

              </Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.entervehicleNo")}
                  value={formik.values.vehicleNo}
                  onChangeText={(text: string) => formik.setFieldValue("vehicleNo", text)}
                  required={true}  // Set required to true
                  lang={lang}
                />
                {formik.touched.vehicleNo && formik.errors.vehicleNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.vehicleNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.SimNo")}
                  value={formik.values.simNo} // Ensure this is pointing to the correct state
                  onChangeText={(text: string) => formik.setFieldValue("simNo", text)} // This should correctly update Formik's state
                  required={true} // Ensure this is set to true if the field is required
                  lang={lang}
                />
                {formik.touched.simNo && formik.errors.simNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.simNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={mrnTypeOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("simType", newValue?.value.toString());
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.SimType")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.SimCompanyName")}
                  value={formik.values.simCompany}
                  onChangeText={(text: string) => formik.setFieldValue("simCompany", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.SimCompanyName")}
                />
                {formik.touched.simCompany && formik.errors.simCompany ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.simCompany}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.SerialNo")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="serialNo"
                  id="serialNo"
                  placeholder={t("text.serialNo")}
                  onChange={formik.handleChange}
                />
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.ChasisNo")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="chesisNo"
                  id="chesisNo"
                  placeholder={t("text.ChasisNo")}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.enterpurchaseYear")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="purchaseYear"
                  id="purchaseYear"
                  placeholder={t("text.enterpurchaseYear")}
                  onChange={formik.handleChange}
                />
              </Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={empOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("empName", newValue?.label);
                    formik.setFieldValue("empid", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.UnderControlOF")} />}
                    />
                  )}
                />
              </Grid>



              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.EnterDepartment")}
                  value={formik.values.departmentName.toString()}
                  onChangeText={(text: string) => formik.setFieldValue("departmentName", text)}
                  // onChangeText={(text: string | number) => {
                  //   const value = typeof text === "number" ? text : parseInt(text, 10);
                  //   formik.setFieldValue("departmentName", isNaN(value) ? "" : value);
                  // }}
                  
                  required={false}
                  lang={lang}
                // placeholder={t("text.EnterDepartment")}
                />
                {formik.touched.departmentName && formik.errors.departmentName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.departmentName}
                  </div>
                ) : null}
              </Grid> */}


              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={departmentOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    //  formik.setFieldValue("VehicleTypeName", newValue?.label);
                    formik.setFieldValue("deptId", newValue?.value);
                    formik.setFieldValue("departmentName", newValue?.label);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.EnterDepartment")} />}
                    />
                  )}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}> 
                <TranslateTextField
                  label={t("text.Designation1")}
                  value={formik.values.designationName}
                  onChangeText={(text: string) => formik.setFieldValue("designationName", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.Designation")}
                />
                {formik.touched.designationName && formik.errors.designationName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.designationName}
                  </div>
                ) : null}
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={designationOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("designationName", newValue?.label);
                    formik.setFieldValue("desigId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.Designation1")} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={vehicleOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    //  formik.setFieldValue("VehicleTypeName", newValue?.label);
                    formik.setFieldValue("vehicleTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleTypeName")} />}
                    />
                  )}
                />
              </Grid>





              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={brandOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    // formik.setFieldValue("brandname", newValue?.label);
                    formik.setFieldValue("brandTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.BrandType")} />}
                    />
                  )}
                />
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={fuelTypeOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    //formik.setFieldValue("fuelTypename", newValue?.label);
                    formik.setFieldValue("fuelTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.FuelType")} />}
                    />
                  )}
                />
              </Grid>


              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.Weight")}
                  value={String(formik.values.vehicleWeight)}
                  onChangeText={(text: string) => formik.setFieldValue("vehicleWeight", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.Weight")}
                />
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.Weight")}
                  value={formik.values.vehicleWeight !== undefined ? String(formik.values.vehicleWeight) : ''} // Convert number to string for input
                  onChangeText={(text: string) => {
                    const parsedValue = Number(text);
                    if (!isNaN(parsedValue)) { // Check if the input is a valid number
                      formik.setFieldValue("vehicleWeight", parsedValue);
                    }
                  }}
                  required={true} // Set required to true
                  lang={lang}
                // placeholder={t("text.Weight")}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.LitrePerHour")}
                  value={String(formik.values.litrePerHr)} // Convert number to string
                  onChangeText={(text: string) => formik.setFieldValue("litrePerHr", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.LitrePerHour")}
                />
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.LitrePerHour")}
                  value={formik.values.litrePerHr.toString()} // Keep this as a number
                  onChangeText={(text: string) => {
                    const numberValue = parseFloat(text); // Convert text to a number
                    if (!isNaN(numberValue)) {
                      formik.setFieldValue("litrePerHr", numberValue); // Set the value as a number
                    } else {
                      formik.setFieldValue("litrePerHr", ''); // Optionally handle invalid input
                    }
                  }}
                  required={false}
                  lang={lang}
                // placeholder={t("text.LitrePerHour")}
                />
              </Grid>



              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.KMperLitre")}
                  value={formik.values.kmPerLitre.toString()} // Convert number to string
                  onChangeText={(text: string) => formik.setFieldValue("kmPerLitre", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.KMperLitre")}
                />
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.KMperLitre")}
                  value={formik.values.kmPerLitre.toString()} // Keep this as string for display
                  onChangeText={(text: string) => {
                    const value = parseFloat(text); // Convert the input text to a number
                    if (!isNaN(value)) { // Check if the conversion was successful
                      formik.setFieldValue("kmPerLitre", value); // Set the value as a number
                    } else {
                      formik.setFieldValue("kmPerLitre", ''); // Optionally handle invalid input
                    }
                  }}
                  required={false}
                  lang={lang}
                // placeholder={t("text.KMperLitre")}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.DeviceNo")}
                  value={formik.values.devid}
                  onChangeText={(text: string) => formik.setFieldValue("devid", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.DeviceNo")}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={deviceOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("deviceTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.DeviceType")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.RFID1")}
                  value={formik.values.rfid}
                  onChangeText={(text: string) => formik.setFieldValue("rfid", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.RFID1")}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.RFID2")}
                  value={formik.values.rfid2}
                  onChangeText={(text: string) => formik.setFieldValue("rfid2", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.RFID2")}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.AllotedFuel")}
                  value={formik.values.fuelAlloted?.toString() || ''} // Convert number to string
                  onChangeText={(text: string) => formik.setFieldValue("fuelAlloted", text)} // Assuming text is a string
                  required={false}
                  lang={lang}
                // placeholder={t("text.AllotedFuel")}
                />
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.AllotedFuel")}
                  value={formik.values.fuelAlloted?.toString() || ''} // Convert number to string for display
                  onChangeText={(text: string) => {
                    const numberValue = parseFloat(text); // Convert string to number
                    if (!isNaN(numberValue)) {
                      formik.setFieldValue("fuelAlloted", numberValue); // Set the value as a number
                    } else {
                      formik.setFieldValue("fuelAlloted", ''); // Reset if not a valid number
                    }
                  }}
                  required={false}
                  lang={lang}
                />
              </Grid>





              <Grid item lg={12} xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        // checked={formik.values.qcApplicable}
                        onChange={formik.handleChange}
                        name="eScarp"
                      />
                    }
                    label={t("text.SaveEscrapAlso")}
                  />
                </FormGroup>
              </Grid>



              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>

            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default VehicleDetailAdd;